import React from "react";
import Slider from "react-slick";
import snugFitIcon from "../../templates/design-system/features-media/assets/icons/snug-fit-icon.svg";
import warrantyIcon from "../../templates/design-system/features-media/assets/icons/warranty.svg";
import waterproofIcon from "../../templates/design-system/features-media/assets/icons/waterproof.svg";
import greatPriceIcon from "../../templates/design-system/features-media/assets/icons/great-price.svg";
import Image from "components/image";
const Features = () => {


    const features = [
        {
            title: "100% Waterproof",
            icon: waterproofIcon,
            subtitle: "All-Weather Defense"
        },
        {
            title: "Lifetime Warranty",
            icon: warrantyIcon,
            subtitle: "Peace of Mind"
        },
        {
            title: "Snug Fit",
            icon: snugFitIcon,
            subtitle: "Hassle-Free Exchanges"
        },
        {
            title: "Great Price",
            icon: greatPriceIcon,
            subtitle: "Factory Direct Saving"
        }
    ];

    const sliderSettings = {

        dots: false,
        arrows: false,
        infinite: true,
        slidesToScroll: 2,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },


        ]
    };

    return (
        <div
            className="features-list"
        >
            <Slider {...sliderSettings}>
                {features.map((item, index) => (
                    <div className="feature-item-wrapper">
                        <div key={`feature-${index}`} className="feature-item">
                            <div className="feature-item__icon">
                                <Image image={item.icon} alt={item.title} />
                            </div>
                            <div className="feature-item__content">
                                <div className="feature-item__title">
                                    {item.title}
                                </div>
                                <div className="feature-item__subtitle">
                                    {item.subtitle}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>

        </div>
    );
};

export default Features;